/*
 * Copyright (c) 2021 Well Solutions SRL. All Rights Reserved.
 * This software is the proprietary information of Well Solutions SRL.
 * Use is subject to license and non-disclosure terms
 */
import { Observable, of, ReplaySubject, Subject, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoggedInContextProvider } from './logged-in-context.provider';
import { LoggedInUser } from './logged-in-user.model';
import { EnvironmentService } from '@irian-ro/util-environment';

@Injectable()
export class LoggedInUserService implements LoggedInContextProvider {
  private loggedInUser: LoggedInUser = new LoggedInUser();

  private currentUserStatus: ReplaySubject<LoggedInUser> = new ReplaySubject(1);

  constructor(private readonly environmentService: EnvironmentService, private readonly http: HttpClient) {
    this.currentUserStatus.next(this.loggedInUser);
  }

  clearLoggedInUser() {
    this.loggedInUser = new LoggedInUser();
  }

  getLoggedInUserObservable(): Observable<LoggedInUser> {
    return of(this.loggedInUser);
  }

  getLoggedInUser(): LoggedInUser {
    return this.loggedInUser;
  }

  getCurrentUserStatus(): Subject<LoggedInUser> {
    return this.currentUserStatus;
  }

  nextCurrentUserStatus(loggedInUser: LoggedInUser): void {
    this.currentUserStatus.next(loggedInUser);
  }

  getLoggedInContextFromServer(): Observable<LoggedInUser> {
    let url = '/api/loggedIn';
    if (this.environmentService && this.environmentService.getEnvironmentProperty('authUrl')) {
      url = `${this.environmentService.getEnvironmentProperty('authUrl')}/loggedIn`;
    }

    const headers = new HttpHeaders({
      'X-Ignore-Http-Header-Interceptor': 'true',
    });

    return this.http
      .get<LoggedInUser>(url, {
        headers: headers,
      })
      .pipe(
        tap((loggedInUser) => {
          this.loggedInUser = loggedInUser;
        }),
        catchError((err) => throwError(err))
      );
  }
}
